<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { addonInputTypes } from 'src/helpers/addons/addon_helpers';
	import { getNumberInputConfig } from '../../../helpers/number_input_helpers';
	//Design system components
	import { Input, Text } from '@Shelly/shelly-design-system';
	//Types
	import type { PeripheralOffsetSettings, PeripheralTypes } from 'src/types/Peripherals';
	import { valueOutOfDecimalRange, valueOutOfRange } from 'src/helpers/utilities';

	let className = '';
	export { className as class };

	export let settings: PeripheralOffsetSettings,
		type: PeripheralTypes,
		icon: string = '',
		error = '';

	const inputType = addonInputTypes[type];
	const min = inputType['offsetMin'];
	const max = inputType['offsetMax'];
	const unit = (type == 'temperature' ? '°' : '') + inputType['unit'];

	$: error =
		(type == 'temperature' ? settings.offset_C : settings.offset) === '' ||
		valueOutOfRange(Number(type == 'temperature' ? settings.offset_C : settings.offset), min, max)
			? $format('min_max_error_description', {
					values: { min: min + unit, max: max + unit },
					default: `Value must be between ${min} and ${max}.`,
				})
			: valueOutOfDecimalRange(type == 'temperature' ? settings.offset_C : settings.offset);
</script>

<div class={className}>
	{#if type == 'temperature'}
		<Input
			{...getNumberInputConfig()}
			size="m"
			class="mb-s"
			{icon}
			bind:value={settings.offset_C}
			{error}
			id="input-zv0himy"
			aria-label={$format('input_temp_offset', {
				default: 'Temperature peripheral input',
			})}
		/>
	{:else}
		<Input
			{...getNumberInputConfig()}
			size="m"
			class="mb-s"
			{icon}
			bind:value={settings.offset}
			{error}
			id="input-5avh7ns"
			aria-label={$format('input_hum_offset', {
				default: 'Humidity peripheral input',
			})}
		/>
	{/if}
	<Text styleType="body-small">
		{$format('min_max_unit_range', {
			default: `(Minimum: ${min + unit}, Maximum: ${max + unit})`,
			values: { min: min + unit, max: max + unit },
		})}
	</Text>
</div>
